import emailjs from 'emailjs-com';

const sendEmail = message => {
    emailjs.send(
        'service_80h1on5',
        'template_YCnVCzDw',
        {"message_html": message},
        'user_zejbbu6SzAxjdW8qFLnAE')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
};
export default sendEmail;

